import moment from "moment"

const formatDate = date => moment(date).format('ddd Do MMM YY')

const formatYear = node => moment.parseZone(node.year).year()

const capitalize = name => {
  return name.replace(/\b([A-Za-zÑÁÉÍÓÚñáéíóú])([A-Za-zÑÁÉÍÓÚñáéíóú]*)/g, (_, p1, p2) => p1.toUpperCase() + p2.toLowerCase())
}

export {
  formatDate,
  formatYear,
  capitalize
}